/* eslint-disable import/prefer-default-export */

import { MODELS_ADD } from 'src/store/ActionTypes';

export const fetchSegments = (query) => ({
  type: MODELS_ADD.FETCH_SEGMENTS,
  payload: query,
});

export const addModel = (model) => ({
  type: MODELS_ADD.ADD_MODEL,
  payload: model,
});
